/**
 * Log Payment Enums - Đồng bộ với backend Laravel/NestJS
 * Không hardcode string/number trong component
 */

/**
 * Payment Method Enum
 * Đồng bộ với backend enum
 */
export const PaymentMethodEnum = {
  BANK_TRANSFER: 1,
  CARD_PAYMENT: 2,
  CASH: 3
};

// Map code ↔ label (phục vụ preview và payload text)
export const PaymentMethodLabel = {
  1: 'Chuyển khoản',
  2: 'Quẹt thẻ',
  3: 'Tiền mặt'
};

export const PaymentMethodCodeByLabel = {
  'Chuyển khoản': 1,
  'Quẹt thẻ': 2,
  'Tiền mặt': 3
};

/**
 * Card Purpose Enum
 * Đồng bộ với backend enum
 */
export const CardPurposeEnum = {
  PAY_FULL: 0, // Trả thẳng
  INSTALLMENT: 1 // Trả góp
};

export const CardPurposeLabel = {
  0: 'Trả thẳng',
  1: 'Trả góp'
};

/**
 * Validation Field Labels Enum
 * Để hiển thị label ngắn gọn trong error
 */
export const LogPaymentFieldLabelEnum = {
  CUSTOMER_PHONE: 'Số điện thoại',
  CONTRACT_ID: 'Mã hợp đồng',
  AMOUNT: 'Số tiền nạp',
  PAYMENT_METHOD: 'Hình thức thanh toán',
  RECIPIENT_ACCOUNT: 'Tài khoản nhận tiền',
  CARD_PURPOSE: 'Mục đích quẹt thẻ',
  FEE_PAYMENT_METHOD: 'Hình thức thanh toán phí'
};

/**
 * Validation Error Codes Enum
 * Đồng bộ với backend error codes
 */
export const LogPaymentValidationErrorCodeEnum = {
  REQUIRED_FIELD: 'REQUIRED_FIELD',
  INVALID_FORMAT: 'INVALID_FORMAT',
  INVALID_VALUE: 'INVALID_VALUE',
  CONDITIONAL_REQUIRED: 'CONDITIONAL_REQUIRED'
};

// Recipient account labels (1: Cá nhân, 2: Công ty)
export const RecipientAccountLabel = {
  1: 'Cá nhân',
  2: 'Công ty'
};

// Fee payment method labels
export const FeePaymentMethodLabel = {
  1: 'Quẹt máy Pos',
  2: 'Chuyển khoản công ty',
  3: 'Chuyển khoản cá nhân',
  4: 'Tiền mặt'
};
